import {Component, Inject, OnInit} from '@angular/core';
import {MD_DIALOG_DATA, MdDialogRef} from '@angular/material';
import {ContractFieldGroupService} from '../../services/contract-field-group/contract-field-group.service';
import {ColumnEditorParameters} from './ColumnEditorParameters';
import {transformEnumLabel} from '../../../utilities/services/enum-helpers/enum-helpers';
import {EFieldGroupType} from '../../../form-builder/enums/e-field-group-type.enum';
import {EFieldGroupUsageType} from '../../../form-builder/enums/e-group-usage-type.enum';
import {ScheduleColumn} from '../../interfaces/ScheduleColumn';
import {PossibleScheduleColumnsService} from '../../services/possible-schedule-columns/possible-schedule-columns.service';
import {FlightScheduleColumnsService} from '../../services/flight-schedule-columns/flight-schedule-columns.service';
import {DeleteItemService} from '../../../utilities/services/delete-item/delete-item.service';

@Component({
  selector: 'app-flight-schedule-column-editor',
  templateUrl: './flight-schedule-column-editor-dialog.component.html',
  styleUrls: ['./flight-schedule-column-editor-dialog.component.scss']
})
export class FlightScheduleColumnEditorComponent implements OnInit {
  protected selectedPossibleColumnIndex = null;
  protected contractId;
  public possibleColumns?: ScheduleColumn[];
  public scheduleColumns?: ScheduleColumn[];
  public loading = true;
  public incrementalLoading = false;
  constructor(
    public dialogRef: MdDialogRef<FlightScheduleColumnEditorComponent>,
    public possibleScheduleColumnService: PossibleScheduleColumnsService,
    public scheduleColumnsService: FlightScheduleColumnsService,
    @Inject(MD_DIALOG_DATA) public data: ColumnEditorParameters,
    private deleteItemService: DeleteItemService
  ) { }

  ngOnInit() {
    this.contractId = this.data.contractId;
    this.load();
  }

  public load() {
    this.scheduleColumnsService.getScheduleColumns(this.contractId).then((savedColumns) => {
      this.scheduleColumns = savedColumns;
      console.log(savedColumns);
      this.possibleScheduleColumnService
        .getScheduleColumns(this.data.contractId, savedColumns).then((columns) => {
        this.possibleColumns = columns;
        this.loading = false;
      });
    });
  }


  public done() {
    this.dialogRef.close(this.scheduleColumns);
  }

  public addColumn() {
    this.incrementalLoading = true;
    const possibleColumn = this.possibleColumns.splice(this.selectedPossibleColumnIndex, 1)[0];
    this.selectedPossibleColumnIndex = null;
    this.scheduleColumnsService.storeScheduleColumn(possibleColumn).then((column) => {
      this.scheduleColumns.push(column);
      this.incrementalLoading = false;
    });
  }

  /**
   * Delete the column at the given index
   * @param index
   */
  public removeColumn(index) {
    const columnToDelete = this.scheduleColumns[index];
    this.deleteItemService.openDialog(columnToDelete.field.name, columnToDelete.field.name,
      'Are you sure you want to delete this?', columnToDelete.id)
      .subscribe(result => {
        if (result) {
          this.incrementalLoading = true;
          this.scheduleColumns.splice(index, 1);
          this.scheduleColumnsService.deleteScheduleColumn(columnToDelete).then(() => {
            this.possibleScheduleColumnService
              .getScheduleColumns(this.data.contractId, this.scheduleColumns).then((columns) => {
              this.possibleColumns = columns;
              this.incrementalLoading = false;
            });
          });
        }
      });
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/contract/components/flight-schedule-column-editor-dialog/flight-schedule-column-editor-dialog.component.ts